var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { staticClass: "row bg-white", attrs: { show: _vm.loading } },
    [
      _c("div", { staticClass: "col-12 mt-3" }, [
        _vm._v(
          " ¿Estás seguro de que quieres anular el Lote Nº " +
            _vm._s(_vm.batch.folio) +
            "? "
        )
      ]),
      _c(
        "div",
        { staticClass: "col-12 mt-3" },
        [
          _c(
            "b-form",
            { attrs: { id: "form-message", "data-vv-scope": "form-message" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Motivo por el que se anula el lote",
                            "label-for": "#"
                          }
                        },
                        [
                          _c(
                            "b-input-group",
                            { staticClass: "input-group-merge" },
                            [
                              _c(
                                "b-input-group-prepend",
                                { attrs: { "is-text": "" } },
                                [
                                  _c("feather-icon", {
                                    attrs: { icon: "HelpCircleIcon" }
                                  })
                                ],
                                1
                              ),
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|min:6",
                                    expression: "'required|min:6'"
                                  }
                                ],
                                attrs: {
                                  placeholder: "Anulado por no....",
                                  "data-cy": "cause",
                                  "data-vv-as": "Motivo",
                                  id: "cause",
                                  name: "cause",
                                  state: _vm.errors.has("form-message.cause")
                                    ? false
                                    : null
                                },
                                model: {
                                  value: _vm.cause,
                                  callback: function($$v) {
                                    _vm.cause = $$v
                                  },
                                  expression: "cause"
                                }
                              }),
                              _c("b-form-invalid-feedback", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.errors.first("form-message.cause")
                                    ) +
                                    " "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("vs-divider"),
      _c(
        "b-col",
        { staticClass: "text-right", attrs: { cols: "12" } },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "ripple",
                  rawName: "v-ripple.400",
                  value: "rgba(255, 255, 255, 0.15)",
                  expression: "'rgba(255, 255, 255, 0.15)'",
                  modifiers: { "400": true }
                }
              ],
              attrs: { variant: "primary", "data-cy": "cancel-batch" },
              on: { click: _vm.onCancel }
            },
            [_vm._v(" Si, Estoy seguro! ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }